module.exports = __webpack_public_path__ + "img/wechat_qr.a5fc850e.jpg";